/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVariantRequestPost } from '../../models/create-variant-request-post';
import { CreateVariantResponse } from '../../models/create-variant-response';

export interface VariantsControllerCreateVariant$Params {
      body: CreateVariantRequestPost
}

export function variantsControllerCreateVariant(http: HttpClient, rootUrl: string, params: VariantsControllerCreateVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateVariantResponse>> {
  const rb = new RequestBuilder(rootUrl, variantsControllerCreateVariant.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateVariantResponse>;
    })
  );
}

variantsControllerCreateVariant.PATH = '/planning-projects/v1/projects/variants';
